<template>
  <div class="navbar-fixed">
    <nav class="navbar red darken-1" role="navigation">
    <div class="container">
      <div class="nav-wrapper">
        <router-link id="logo-container" class="brand-logo" to="/">
          <img src="/static/img/logoyaracuy2.png" style="max-height: 60px; margin:2px;" alt class="responsive-img">
        </router-link>
        <ul class="right">
          <li>
            <a class="dropdown-trigger" href="#!" data-target="dropdown1">
              <i class="material-icons right">account_circle</i>
            </a>
            <ul id="dropdown1" class="dropdown-content">
              <li><a href="#!">Perfil</a></li>
              <li class="divider"></li>
              <li><a href="#!" @click.prevent="logout" class="dropdown-item">Salir</a></li>
            </ul>
          </li>

        </ul>
      </div>
    </div>
    </nav>
  </div>
</template>

<script>
import * as M from 'materialize-css'

export default {
  name: 'app-top-bar',
  methods: {
    logout () {
      this.$store.commit('logout')
      this.$router.push({ name: 'login' })
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  mounted () {
    var elems = document.querySelectorAll('.dropdown-trigger')
    M.Dropdown.init(elems, {
      alignment: 'right'
    })
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue